export let colors = {
  licenses: {
    appsFull: '#0099C6',
    appsEmpty: '#E5EAF6',
    gatewaysFull: '#990099',
    gatewaysEmpty: '#E5EAF6',
    membersFull: '#109618',
    membersEmpty: '#E5EAF6',
    membersOver: '#F24E4E',
    emptyValueColor: '#F2F7FF'
  }
};
